import { trackClientEvent } from 'analytics/analytics'

export const EXPERIENCES_HOMEPAGE_UPLIFT_TRACKING_CATEGORY = 'experiences_homepage_uplift'

export type ExperiencesHomepageUpliftTrackingSubject =
  | 'booking_personalisation'
  | 'suggested_searches'
  | 'suggested_searches_global'
  | 'suggested_searches_experience'
  | 'luxplus_top_offers'

export type ExperiencesHomepageUpliftTrackingAction =
  | 'impression'
  | 'explore_now_clicked'
  | 'tile_clicked'
  | 'tile_dismissed'
  | 'clear_all_clicked'
  | 'tab_selected'
  | 'date_filter_selected'
  | 'view_all_clicked'

export function trackExperiencesHomepageUpliftInteraction(
  subject: ExperiencesHomepageUpliftTrackingSubject,
  action: ExperiencesHomepageUpliftTrackingAction,
) {
  trackClientEvent({
    category: EXPERIENCES_HOMEPAGE_UPLIFT_TRACKING_CATEGORY,
    type: 'interaction',
    subject,
    action,
  })
}
